function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.insertNode0{fill:#FFBE54;}\n\t.insertNode1{fill:#37BEB7;}\n\t.insertNode2{fill:none;stroke:#16224A;stroke-width:50;stroke-miterlimit:10;}\n\t.insertNode3{fill:#16224A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode0",
  cx: 520.54,
  cy: 349.72,
  r: 97.33
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode1",
  cx: 168.55,
  cy: 519.86,
  r: 97.33
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode1",
  cx: 168.55,
  cy: 163.91,
  r: 97.33
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 141.31,
  cy: 141.2,
  r: 115.92
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  className: "insertNode2",
  x1: 141.31,
  y1: 398.06,
  x2: 141.31,
  y2: 257.12
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 141.31,
  cy: 498.88,
  r: 115.92
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "insertNode2",
  cx: 498.1,
  cy: 327.59,
  r: 115.92
});

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "insertNode2",
  x1: 390.47,
  y1: 324.96,
  x2: 285.73,
  y2: 324.96
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  className: "insertNode3",
  points: "301.77,270.11 206.79,324.96 301.77,379.81  "
}))));

var SvgInsertNode = function SvgInsertNode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "insertNode",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsertNode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insertNode.4dea837e.svg";
export { ForwardRef as ReactComponent };